import React, { useState, useEffect } from "react";
import axios from "axios";
import { Col, Row } from "react-bootstrap";
import Button from "../../../../component/Button/Button";
import upload from "../../../../images/careers/upload.svg";
import Toast from "../../../../component/Toast/Toast";
import close from "../../../../images/close.svg";
import check from "../../../../images/check.svg";
import Imageurldata from "../../../../Imageurldata";
import config from "../../../../config/config";

const Logo = () => {
  const [loading, setLoading] = useState(false);
  const [logoId, setLogoId] = useState("");

  const [logoImage, setLogoImage] = useState("");
  const [logoPreview, setLogoPreview] = useState("");
  const [logoErr, setLogoErr] = useState("");
  const [logoNew, setLogoNew] = useState(false);

  const allowedTypes = ["image/jpeg", "image/png", "image/webp", "image/jpg"];

  const [toastlist, setToastList] = useState([]);

  const showToast = (type, msg) => {
    const id = Math.floor(Math.random() * 101);
    let toastProperties = {};

    if (type === "success") {
      toastProperties = {
        id,
        title: "Success",
        description: msg || "Logo Saved Successfully",
        backgroundColor: "#329F33",
        icon: check,
      };
    } else {
      toastProperties = {
        id,
        title: "Error",
        description: msg || "Something went wrong",
        backgroundColor: "red",
        icon: close,
      };
    }

    setToastList([...toastlist, toastProperties]);
  };

  const validateImage = (file) => {
    if (!allowedTypes.includes(file.type)) {
      return "*Only JPG, PNG, WEBP images are allowed.";
    }
    return "";
  };

  // ================================
  // GET EXISTING LOGO
  // ================================
  const fetchLogo = () => {
    setLoading(true);
    axios
      .get(`${config.api_url}logo`)
      .then((res) => {
        const data = res.data[0]; // only one logo allowed
        if (data) {
          setLogoId(data._id);
          setLogoImage(data.imageUrl ? Imageurldata + data.imageUrl : "");
          setLogoPreview(data.imageUrl ? Imageurldata + data.imageUrl : "");
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchLogo();
  }, []);

  // ================================
  // SUBMIT (ADD or UPDATE)
  // ================================
  const submit = () => {
    let valid = true;

    if (!logoImage) {
      setLogoErr("*Please upload logo image.");
      valid = false;
    } else setLogoErr("");

    if (!valid) return;

    const formData = new FormData();
    if (logoNew) formData.append("image", logoImage);
    if (logoId) formData.append("id", logoId);

    const url = `${config.api_url}logo/save`;

    setLoading(true);

    axios
      .post(url, formData)
      .then(() => {
        showToast("success", logoId ? "Logo Updated" : "Logo Added");
        fetchLogo();
        setLogoNew(false);
        setLoading(false);
      })
      .catch((err) => {
        const msg = err.response?.data?.error || "Something went wrong";
        showToast("error", msg);
        setLoading(false);
      });
  };

  // ================================
  // IMAGE INPUT UI
  // ================================
  const renderImageInput = () => {
    return (
      <>
        <Col lg={3} className="column">
          <div className="title">Header Logo</div>
          <div className="desc">Recommended: 131 x 116 px</div>
        </Col>

        <Col lg={9} className="column">
          <input
            type="file"
            id="logo_input"
            accept="image/*"
            onChange={(e) => {
              const file = e.target.files[0];
              if (!file) return;

              const error = validateImage(file);
              if (error) {
                setLogoErr(error);
                return;
              }

              setLogoErr("");
              setLogoImage(file);
              setLogoPreview(URL.createObjectURL(file));
              setLogoNew(true);
            }}
          />

          <label htmlFor="logo_input" className="d-f" id="file-drag">
            <img src={upload} className="img-fluid" />
            <div className="chooseTxt">Choose File</div>
          </label>
          <div className="fileTxt">File Format : JPG / PNG </div>

          <div className="err">{logoErr}</div>

          {logoPreview && (
            <img
              src={logoPreview}
              style={{
                width: "120px",
                height: "auto",
                marginTop: "10px",
              }}
            />
          )}
        </Col>
      </>
    );
  };

  return (
    <>
      <h1>Header Logo</h1>

      <Row className="adminhomeaboutSec1">
        {renderImageInput()}

        <Col className="column d-f j-c a-c mt-4">
          <Button onClick={submit} title={logoId ? "UPDATE" : "ADD"} />
        </Col>
      </Row>

      <Toast toastList={toastlist} position="top-right" />
    </>
  );
};

export default Logo;
